import Autocomplete from "@tomickigrzegorz/autocomplete";
import geocoder from "../geocoder";
import { defaults } from "../autocomplete";

export default () => ({
  selected: null,
  autocomplete: null,
  abortController: null,

  init() {
    const geocode = geocoder(false);

    this.autocomplete = new Autocomplete(this.$refs.input.id, {
      ...defaults,
      onSearch: async ({ currentValue }) => {
        this.abortController?.abort();
        this.abortController = new AbortController();

        try {
          const locations = await geocode(
            currentValue,
            {
              includeAddresses: false,
              includeStates: true,
            },
            this.abortController.signal,
          );

          this.abortController = null;
          return locations;
        } catch (error) {
          this.abortController = null;

          if (error.name === "AbortError") {
            return [];
          }

          console.error(error);
          return [];
        }
      },

      onSubmit: async ({ object }) => {
        this.selected = object;
        await this.$nextTick();
        this.$el.closest("form").submit();
      },
    });
  },

  destroy() {
    this.autocomplete?.destroy();
    this.abortController?.abort();
  },
});
